// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styling for the entire application */
/* body styles are now handled by MuiCssBaseline and the theme.js configuration */

/* Common utility elements */
.min-vh-100 {
  min-height: 100vh;
}

.cursor-pointer {
  cursor: pointer;
}

/*
  The following styles (.card, .card-header, .form-control, .table-container, etc.)
  are largely superseded by MUI component styling defined in theme.js.
  They are removed to avoid conflicts and rely on the MUI theme as the single source of truth for component styling.
  If custom non-MUI components need these styles, they should be scoped specifically to those components
  or defined as part of their own stylesheets or styled-component definitions.
*/

/* Specific application/layout styles that may not be directly MUI components */
/* These should be reviewed and potentially refactored to use theme variables or MUI styling if they apply to MUI components */

.report-form-section {
  margin-bottom: 2rem; /* Consider theme.spacing */
  padding-bottom: 1.5rem;
  /* border-bottom: 1px solid var(--mui-palette-divider); */ /* Example using theme variable if available in CSS */
}

.report-form-section:last-child {
  border-bottom: none;
}

/* User role badges - If this is a custom component, styling here is fine. If it's an MUI Chip, style via theme. */
.user-role-label {
  text-transform: capitalize;
}

/* Reports Container - Grid layout for cards */
/* If .reports-container contains MUI Cards, prefer styling the Grid container via sx prop */
.reports-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px; /* Consider theme.spacing */
}

/* Status Indicator - Left vertical bar for report cards */
/* This is a custom visual element, so its styling can remain here. */
/* Ensure colors are updated if they were previously using CSS variables removed from App.css */
.status-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px; /* Consider making this themable if needed */
  height: 100%;
}

/* Example: Update status indicator colors to fixed values or ensure they are set dynamically via JS using the theme */
.status-signed,
.status-completed {
  background-color: #28a745; /* Direct color, or use a class set by JS based on theme.palette.success.main */
}

.status-unsigned,
.status-pending {
  background-color: #F28C28; /* Direct color, or use a class set by JS based on theme.palette.warning.main */
}

.status-scheduled {
  background-color: #17A2B8; /* Direct color, or use a class set by JS based on theme.palette.info.main */
}


/* Report Details (custom classes) */
.detail-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  /* color: var(--mui-palette-text-secondary); */ /* Example */
}

.detail-value {
  font-weight: 500;
  /* color: var(--mui-palette-text-primary); */ /* Example */
}

/* Search and Filter Styles (if custom components) */
.search-bar {
  /* box-shadow: var(--mui-shadows-1); */ /* Example */
  border-radius: 8px; /* var(--mui-shape-borderRadius) */
  overflow: hidden;
  /* background-color: var(--mui-palette-background-paper); */ /* Example */
}

.filter-panel {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  /* background-color: var(--mui-palette-background-paper); */ /* Example */
}

.filter-panel.show {
  max-height: 500px; /* Adjust as needed */
}

.filter-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 20px; /* Or theme.shape.borderRadius * 2.5 */
  /* border: 1px solid var(--mui-palette-divider); */ /* Example */
  /* background-color: var(--mui-palette-action-hover); */ /* Example */
  padding: 4px 8px;
}

.filter-label {
  /* color: var(--mui-palette-text-secondary); */ /* Example */
  margin-right: 4px;
  font-size: 0.8rem;
}

/* Empty State (if custom component) */
.empty-state-icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: var(--mui-palette-action-disabledBackground); */ /* Example */
  border-radius: 50%;
}


/* Error display (if custom component) */
.error-icon {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-radius: 50%;
  /* background-color: alpha(theme.palette.error.main, 0.1); */ /* Example if used in JS with theme access */
  /* For CSS only: background-color: rgba(220, 53, 69, 0.1); */
}


/* Skeleton styles are now primarily handled by MuiSkeleton and theme overrides. */
/* Remove .skeleton-card, .skeleton-status, .skeleton-line, .skeleton-actions, .skeleton-button */
/* Any dark mode specific skeleton styles like .dark-mode .skeleton-card are also removed. */


/* Media Queries for Responsive Design */
@media (max-width: 768px) {
  .reports-container {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
  /* .status-badge { font-size: 0.75em; } // If .status-badge is kept and is not an MUI Chip */
}

@media (max-width: 576px) {
  .reports-container {
    grid-template-columns: 1fr; /* Full width on very small screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C,iFAAiF;;AAEjF,4BAA4B;AAC5B;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;CAMC;;AAED,+EAA+E;AAC/E,8HAA8H;;AAE9H;EACE,mBAAmB,EAAE,2BAA2B;EAChD,sBAAsB;EACtB,yDAAyD,EAAE,qDAAqD;AAClH;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kHAAkH;AAClH;EACE,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C,4FAA4F;AAC5F;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS,EAAE,2BAA2B;AACxC;;AAEA,0DAA0D;AAC1D,qEAAqE;AACrE,+FAA+F;AAC/F;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU,EAAE,4CAA4C;EACxD,YAAY;AACd;;AAEA,sHAAsH;AACtH;;EAEE,yBAAyB,EAAE,+EAA+E;AAC5G;;AAEA;;EAEE,yBAAyB,EAAE,+EAA+E;AAC5G;;AAEA;EACE,yBAAyB,EAAE,4EAA4E;AACzG;;;AAGA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,8CAA8C,EAAE,YAAY;AAC9D;;AAEA;EACE,gBAAgB;EAChB,4CAA4C,EAAE,YAAY;AAC5D;;AAEA,oDAAoD;AACpD;EACE,sCAAsC,EAAE,YAAY;EACpD,kBAAkB,EAAE,kCAAkC;EACtD,gBAAgB;EAChB,2DAA2D,EAAE,YAAY;AAC3E;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,2DAA2D,EAAE,YAAY;AAC3E;;AAEA;EACE,iBAAiB,EAAE,qBAAqB;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB,EAAE,sCAAsC;EAC3D,kDAAkD,EAAE,YAAY;EAChE,uDAAuD,EAAE,YAAY;EACrE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C,EAAE,YAAY;EAC5D,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oEAAoE,EAAE,YAAY;EAClF,kBAAkB;AACpB;;;AAGA,wCAAwC;AACxC;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,4DAA4D,EAAE,4CAA4C;EAC1G,4DAA4D;AAC9D;;;AAGA,kFAAkF;AAClF,iGAAiG;AACjG,4FAA4F;;;AAG5F,wCAAwC;AACxC;EACE;IACE,4DAA4D;EAC9D;EACA,4FAA4F;AAC9F;;AAEA;EACE;IACE,0BAA0B,EAAE,qCAAqC;EACnE;AACF","sourcesContent":["/* Base styling for the entire application */\n/* body styles are now handled by MuiCssBaseline and the theme.js configuration */\n\n/* Common utility elements */\n.min-vh-100 {\n  min-height: 100vh;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n/*\n  The following styles (.card, .card-header, .form-control, .table-container, etc.)\n  are largely superseded by MUI component styling defined in theme.js.\n  They are removed to avoid conflicts and rely on the MUI theme as the single source of truth for component styling.\n  If custom non-MUI components need these styles, they should be scoped specifically to those components\n  or defined as part of their own stylesheets or styled-component definitions.\n*/\n\n/* Specific application/layout styles that may not be directly MUI components */\n/* These should be reviewed and potentially refactored to use theme variables or MUI styling if they apply to MUI components */\n\n.report-form-section {\n  margin-bottom: 2rem; /* Consider theme.spacing */\n  padding-bottom: 1.5rem;\n  /* border-bottom: 1px solid var(--mui-palette-divider); */ /* Example using theme variable if available in CSS */\n}\n\n.report-form-section:last-child {\n  border-bottom: none;\n}\n\n/* User role badges - If this is a custom component, styling here is fine. If it's an MUI Chip, style via theme. */\n.user-role-label {\n  text-transform: capitalize;\n}\n\n/* Reports Container - Grid layout for cards */\n/* If .reports-container contains MUI Cards, prefer styling the Grid container via sx prop */\n.reports-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px; /* Consider theme.spacing */\n}\n\n/* Status Indicator - Left vertical bar for report cards */\n/* This is a custom visual element, so its styling can remain here. */\n/* Ensure colors are updated if they were previously using CSS variables removed from App.css */\n.status-indicator {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px; /* Consider making this themable if needed */\n  height: 100%;\n}\n\n/* Example: Update status indicator colors to fixed values or ensure they are set dynamically via JS using the theme */\n.status-signed,\n.status-completed {\n  background-color: #28a745; /* Direct color, or use a class set by JS based on theme.palette.success.main */\n}\n\n.status-unsigned,\n.status-pending {\n  background-color: #F28C28; /* Direct color, or use a class set by JS based on theme.palette.warning.main */\n}\n\n.status-scheduled {\n  background-color: #17A2B8; /* Direct color, or use a class set by JS based on theme.palette.info.main */\n}\n\n\n/* Report Details (custom classes) */\n.detail-label {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  /* color: var(--mui-palette-text-secondary); */ /* Example */\n}\n\n.detail-value {\n  font-weight: 500;\n  /* color: var(--mui-palette-text-primary); */ /* Example */\n}\n\n/* Search and Filter Styles (if custom components) */\n.search-bar {\n  /* box-shadow: var(--mui-shadows-1); */ /* Example */\n  border-radius: 8px; /* var(--mui-shape-borderRadius) */\n  overflow: hidden;\n  /* background-color: var(--mui-palette-background-paper); */ /* Example */\n}\n\n.filter-panel {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease-out;\n  /* background-color: var(--mui-palette-background-paper); */ /* Example */\n}\n\n.filter-panel.show {\n  max-height: 500px; /* Adjust as needed */\n}\n\n.filter-badge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 20px; /* Or theme.shape.borderRadius * 2.5 */\n  /* border: 1px solid var(--mui-palette-divider); */ /* Example */\n  /* background-color: var(--mui-palette-action-hover); */ /* Example */\n  padding: 4px 8px;\n}\n\n.filter-label {\n  /* color: var(--mui-palette-text-secondary); */ /* Example */\n  margin-right: 4px;\n  font-size: 0.8rem;\n}\n\n/* Empty State (if custom component) */\n.empty-state-icon {\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* background-color: var(--mui-palette-action-disabledBackground); */ /* Example */\n  border-radius: 50%;\n}\n\n\n/* Error display (if custom component) */\n.error-icon {\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  border-radius: 50%;\n  /* background-color: alpha(theme.palette.error.main, 0.1); */ /* Example if used in JS with theme access */\n  /* For CSS only: background-color: rgba(220, 53, 69, 0.1); */\n}\n\n\n/* Skeleton styles are now primarily handled by MuiSkeleton and theme overrides. */\n/* Remove .skeleton-card, .skeleton-status, .skeleton-line, .skeleton-actions, .skeleton-button */\n/* Any dark mode specific skeleton styles like .dark-mode .skeleton-card are also removed. */\n\n\n/* Media Queries for Responsive Design */\n@media (max-width: 768px) {\n  .reports-container {\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  }\n  /* .status-badge { font-size: 0.75em; } // If .status-badge is kept and is not an MUI Chip */\n}\n\n@media (max-width: 576px) {\n  .reports-container {\n    grid-template-columns: 1fr; /* Full width on very small screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
